module.exports = __webpack_public_path__ + "assets/forgot-password-v2.97d6f576.svg";